module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('div', {
    staticClass: "c-navbar"
  }, [_c('div', {
    staticClass: "left",
    on: {
      "click": _vm.goBack
    }
  }, [_c('div', {
    staticClass: "back-icon"
  }), _vm._v(" "), _c('div', [_vm._v("返回")])]), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_vm._v("\n    " + _vm._s(_vm.title) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [(_vm.right) ? _c('span', {
    on: {
      "click": _vm.rightBtnClick
    }
  }, [_vm._v(_vm._s(_vm.rightText))]) : _vm._e()])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-75a804e6","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/public-lib/vue-components/src/components/c-navbar/index.vue
// module id = 380
// module chunks = 0